/**
 *
 * @author Matthew Rawson
 * ButtonRouterLink has been extended out to auto include load promise handling displaying a loader when processing and
 * then reverting to the displaying the children when not processing. This will override the disabled state when
 * processing.
 *
 */
import React, {Component} from "react"

import id from "@irati/utils/id"
import {isPromise} from "@irati/utils/promise"
import Loader from "@irati/ui/src/Loading/Loader"

import {Props as RouterLinkProps} from "../../RouterLink"
import {ButtonRouterLinkUI, ChildWrapper} from "./styled"
import {ButtonCssProps} from "../../../Button/styled"

interface Props extends RouterLinkProps, ButtonCssProps {
  load?: Promise<any> | null
}

interface State {
  processing?: boolean
}

class ButtonRouterLink extends Component<Props, State> {
  static defaultProps = {
    load: Promise.resolve()
  }

  state: State = {
    processing: false
  }

  _isMounted = false

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    /** Receive events from the load promise chain  */
    if (isPromise(nextProps.load)) {
      if (nextProps.load !== this.props.load) {
        this.setProcessing(true)

        nextProps.load
          .then(() => {
            this.setProcessing()
          })
          .catch((err) => {
            this.setProcessing()
            throw err
          })
      }
    } else {
      this.setProcessing()
    }
  }

  setProcessing = (processing?: boolean) => {
    if (this._isMounted) {
      this.setState({processing})
    }
  }

  render() {
    const idNamespace = id("ButtonRouterLink", this.props)
    const {load, children, disabled, ...routerLinkProps} = this.props
    const {processing} = this.state

    return (
      <ButtonRouterLinkUI {...routerLinkProps} disabled={disabled || processing} plain>
        {processing && <Loader id={id("Loader", idNamespace)} />}

        <ChildWrapper id={id("ChildWrapper", idNamespace)} className="button-router-link-child-wrapper" processing={processing}>
          {children}
        </ChildWrapper>
      </ButtonRouterLinkUI>
    )
  }
}

export default ButtonRouterLink
